// Dropdown for auction listing source
export const sourceOptions = [
  {
    key: "wildlifebuyer",
    value: "Wildlife Buyer",
    disabled: false,
  },
  {
    key: "exoticauction",
    value: "Exotic Auction",
    disabled: false,
  },
];

//Dropdown for gender
export const genderOptions = [
  { key: "All", value: "All" },
  { key: "male", value: "Male" },
  { key: "female", value: "Female" },
  { key: "male_calf", value: "Male Calf" },
  { key: "female_calf", value: "Female Calf" },
  { key: "unsexed_calf", value: "Unsexed Calf" },
];